import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import { type TreatmentTopicImagePlacementType } from '@modules/drugs/helpers/images/consts'

const TreatmentConjuredImageAltMap: Record<
  TreatmentTopicImagePlacementType,
  string
> = {
  dosage:
    'image of drug pills surrounding a glass of water symbolizing drug consumption',
  effectiveness: 'image of a doctor in a lab doing drug, clinical research',
  whatIs: 'image of different drug pills on a surface',
}

export default function TreatmentConjuredImage({
  images,
  placement,
}: {
  images: { externalId: string; id: number; placement: string }[] | null
  placement: TreatmentTopicImagePlacementType
}) {
  const image = (images ?? []).find((img) => img.placement === placement)

  if (!image) {
    return null
  }

  return (
    <div className='my-2 w-full'>
      <CloudflareImage
        alt={TreatmentConjuredImageAltMap[placement]}
        className={'rounded-xl border border-neutral100'}
        height={341}
        imageId={image.externalId}
        style={{ objectFit: 'cover' }}
        title={TreatmentConjuredImageAltMap[placement]}
        width={1366}
      />
    </div>
  )
}
